import { filterDate_template } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterDate_template";
import { multipleSelector_template } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/multipleSelector_template";
import { vnTemplate } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import { amCharts_v4_column_chart } from "./amCharts_v4_column_chart";

import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import { filterPreset_template } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterPreset_template";
import { amCharts_v4_pie_chart } from "./amCharts_v4_pie_chart";

declare var ko: any;

export class content_value_reporting_template extends vnTemplate {
    protected filterContentType: multipleSelector_template;
    protected dateFilter: filterDate_template;
    protected contentValueReport: amCharts_v4_column_chart;
    protected contentValueReportEngagement: amCharts_v4_column_chart;
    protected contentSuggestionUsageReport: amCharts_v4_column_chart;
    protected filterPreset: filterPreset_template;
    protected contentSuggestionsUsageAffiliate: amCharts_v4_pie_chart;
    protected contentSuggestionsUsageAuthority: amCharts_v4_pie_chart;
    protected contentSuggestionsUsageFeature: amCharts_v4_pie_chart;
    protected contentSuggestionsUsageList: amCharts_v4_pie_chart;
    protected contentSuggestionsUsageNews: amCharts_v4_pie_chart;
    protected contentSuggestionsUsageResource: amCharts_v4_pie_chart;

    public groupNames = ['Affiliate', 'Authority', 'Feature', 'List', 'News', 'Resource'];

    protected getTemplateHtml(): string {
        return /*html*/ `
        <div class="sub-header filter-preset w-justify">
            ${this.filterPreset.getHtmlBuild()}
        </div>
        <div class="sub-header w-justify">
            <div class="w-justify" style="z-index: 9999">
                <div class="w-left">
                <!-- ko if: (brand() != null) -->
                    ${this.dateFilter.getHtmlBuild()}
                <!-- /ko -->
                    ${this.filterContentType.getHtmlBuild()}
                </div>
            </div>
        </div>

        <!--dashboard body -->
        <div class="w-dashboard" id="w-dashboard">
            <div class="dashboard" id="dashboard">
                <div class="w-card">
                    <div class="form-pagination">
                        
                        <button class="btn icon" type="button" data-bind="event: { click: onClickTabLeft.bind($data,'badgeCount') }, css: { 'is-activated' : selectedTabLeft() == 'badgeCount'}">
                            <span class="btn-text">Badge Count per content type</span>
                        </button>               
                        <button class="btn icon" type="button" data-bind="event: { click: onClickTabLeft.bind($data,'contentSuggestionsUsage') }, css: { 'is-activated' : selectedTabLeft() == 'contentSuggestionsUsage'}">
                            <span class="btn-text">Content Suggestions Usage</span>
                        </button>
                    </div>
                    <div class="w-tabs-content" data-bind="css: { 'is-showing' : selectedTabLeft() == 'badgeCount'}">
                        <div class="w-chart-external-legend">
                            ${this.contentValueReport.getHtmlBuild()}
                        </div>
                        <div class="form-pagination">
                            <button class="btn icon is-activated" type="button">
                                <span class="btn-text">Average Time on Page By Badge</span>
                            </button>
                        </div>
                
                        <div class="w-chart-external-legend">
                            ${this.contentValueReportEngagement.getHtmlBuild()}
                        </div>
                    </div>
                    <div class="w-tabs-content" data-bind="css: { 'is-showing' : selectedTabLeft() == 'contentSuggestionsUsage'}">
                        <div class="w-pie">
                            <div class="pie">
                                
                                <div class="pie-title"><span>Affiliate</span></div>
                                    ${this.contentSuggestionsUsageAffiliate.getHtmlBuild()}
                                </div>
                                <div class="pie">
                                    <div class="pie-title"><span>Authority</span></div>
                                    ${this.contentSuggestionsUsageAuthority.getHtmlBuild()}
                                </div>
                                <div class="pie">
                                    <div class="pie-title"><span>Feature</span></div>
                                    ${this.contentSuggestionsUsageFeature.getHtmlBuild()}
                                </div>
                                <div class="pie">
                                    <div class="pie-title"><span>List</span></div>
                                    ${this.contentSuggestionsUsageList.getHtmlBuild()}
                                </div>
                                <div class="pie">
                                    <div class="pie-title"><span>News</span></div>
                                    ${this.contentSuggestionsUsageNews.getHtmlBuild()}
                                </div>
                                <div class="pie">
                                    <div class="pie-title"><span>Resource</span></div>
                                    ${this.contentSuggestionsUsageResource.getHtmlBuild()}
                                </div>
                                <div class="legend span-2">
                                    <div class="legend-item news">With Suggestions</div>
                                    <div class="legend-item authority">Without Suggestions</div>
                                </div>
                        </div>
                        <div class="form-pagination">
                            <button class="btn icon is-activated" type="button">
                                <span class="btn-text">Average Time on Page By Suggestions</span>
                            </button>
                        </div>
                
                        <div class="w-chart-external-legend">
                            ${this.contentSuggestionUsageReport.getHtmlBuild()}
                        </div>
                        <!-- ko if: (brand() == null) -->
                            <div class="form-pagination">
                                <button class="btn icon is-activated" type="button">
                                    <span class="btn-text">Count of Content Suggestions By Brand</span>
                                </button>
                            </div>
                            <table class="list-results" style="padding: 5px; margin-left: 1%; width: 98%; margin-bottom: 15px">
                                <thead>
                                    <th><span>Brand</span></th>
                                    <th><span>No Content Suggestions</span></th>
                                    <th><span>With Content Suggestions</span></th>
                                </thead>
                                <tbody data-bind="foreach: contentSuggestionsCountByBrand">
                                    <tr class="brand-row">
                                        <td data-bind="text: shortName"></td>
                                        <td data-bind="text: noSuggestions"></td>
                                        <td data-bind="text: containSuggestions"></td>
                                    </tr>
                                </tbody>
                            </table>
                        <!-- /ko -->
                    </div>
                </div>
                
            </div>
        </div>

    `;
    }
    protected buildViewModel(): any {
        let _this = this;
        return {
            sensaiData: ko.observableArray([]),
            brand: ko.observable(null),
            contentTypeGroups: ko.observableArray([]),
            contentValueReport: ko.observableArray([]),
            contentSuggestionsUsageAffiliate: ko.observableArray([]),
            contentSuggestionsUsageAuthority: ko.observableArray([]),
            contentSuggestionsUsageFeature: ko.observableArray([]),
            contentSuggestionsUsageList: ko.observableArray([]),
            contentSuggestionsUsageNews: ko.observableArray([]),
            contentSuggestionsUsageResource: ko.observableArray([]),            
            contentValueEngagementReport: ko.observableArray([]),
            contentSuggestionUsageReport: ko.observableArray([]),
            contentSuggestionsCountByBrand: ko.observableArray([]),
            selectedTabLeft: ko.observable("badgeCount", "contentSuggestionsUsage"),
            onClickTabLeft: function (value, data, event) {
                _this.onClickTabLeft(value);
            },
        };
    }

    public getViewModelForRequest(){

        return {
            searchPresetName: this.getTemplateViewModel().filterPreset.searchPresetName(),
            searchPresetType: 'authorManagement',
            filters      : {
                dateFilterType: this.getTemplateViewModel().dateFilter.selectedFilter(),
                startDate: this.getTemplateViewModel().dateFilter.startDate(),
                endDate: this.getTemplateViewModel().dateFilter.endDate(),
                startDateRange: this.getTemplateViewModel().dateFilter.fromRange(),
                endDateRange: this.getTemplateViewModel().dateFilter.toRange(),
                contentTypeIds: this.getTemplateViewModel().filterContentType.selectedItems,
            }
        }
                    
    }

    protected initPartial(): void {

        this.filterContentType = new multipleSelector_template("filterContentType",this.getTemplateViewModel(),this.caller);
        this.filterContentType.setLabel("Content Type");
        this.filterContentType.setTagContainerId("selected-contentType");
        this.filterContentType.setTagContainerCaption("Selected content type:");

        this.dateFilter = new filterDate_template("dateFilter",this.getTemplateViewModel(),this.caller);
        this.setDefaultDateRange();

        this.contentValueReport = new amCharts_v4_column_chart("amCharts_v4_column_chart",this.getTemplateViewModel(),this.caller);
        this.contentValueReport.setXAxisRotation(-90);
        this.contentValueReport.setXAxisFontSize(14);

        this.contentValueReportEngagement = new amCharts_v4_column_chart("amCharts_v4_column_chart_engagement",this.getTemplateViewModel(),this.caller);
        this.contentValueReportEngagement.setXAxisRotation(-90);
        this.contentValueReportEngagement.setXAxisFontSize(14);

        this.contentSuggestionUsageReport = new amCharts_v4_column_chart("amCharts_v4_column_chart_suggestionUsage",this.getTemplateViewModel(),this.caller);
        this.contentSuggestionUsageReport.setXAxisRotation(-90);
        this.contentSuggestionUsageReport.setXAxisFontSize(14);

        this.filterPreset = new filterPreset_template("filterPreset", this.getTemplateViewModel(), this.caller);
        this.filterPreset.getTemplateViewModel().searchPresetType('contentValueReport');

        this.contentSuggestionsUsageAffiliate = new amCharts_v4_pie_chart("amCharts_v4_pie_chart_affiliate",this.getTemplateViewModel(),this.caller);
        this.contentSuggestionsUsageAuthority = new amCharts_v4_pie_chart("amCharts_v4_pie_chart_authority",this.getTemplateViewModel(),this.caller);
        this.contentSuggestionsUsageFeature = new amCharts_v4_pie_chart("amCharts_v4_pie_chart_feature",this.getTemplateViewModel(),this.caller);
        this.contentSuggestionsUsageList = new amCharts_v4_pie_chart("amCharts_v4_pie_chart_list",this.getTemplateViewModel(),this.caller);
        this.contentSuggestionsUsageNews = new amCharts_v4_pie_chart("amCharts_v4_pie_chart_news",this.getTemplateViewModel(),this.caller);
        this.contentSuggestionsUsageResource = new amCharts_v4_pie_chart("amCharts_v4_pie_chart_resource",this.getTemplateViewModel(),this.caller);
    }

    protected getTemplateName(): string {
        return "content_value_reporting_template";
    }
    protected getMainElementType(): string {
        return "div";
    }

    protected getMainElementClasses(): Array<string> {
        return ["w-content"];
    }
    public setGroupContentTypeFilterItems(groupContentTypes: any) {
        let groups = [];

        for (let groupContentType of groupContentTypes) {

            if(groupContentType.id == 7 || groupContentType.id == 8) {
                continue;
            }
            let group = {
                name: groupContentType.name,
                items: groupContentType.contentTypes,
            };
            groups.push(group);
        }

        this.filterContentType.setMultiSectionItems(groups);
        this.filterContentType.setLabel("Content Type");
    }
    public setDefaultDateRange() {
        // date filters.
        this.dateFilter.getTemplateViewModel().selectedFilter("range");
        if(this.caller.getVnAppZone().app.params.idBrand) {
            this.dateFilter.setRange("-30d", "-1d");    
        }else{

            this.dateFilter.setRange("-30d", null);
        }
    }
    public setContentValueReport(contentValueReport: any): void {
        this.getTemplateViewModel().contentValueReport(contentValueReport);

        contentValueReport.category = "category";
        contentValueReport.yAxis = "badgeCount";
        contentValueReport.xAxis = "category";
        contentValueReport.name = "Count";
        contentValueReport.horizontalCenter = "middle";
        contentValueReport.minimalValue = 0;

        contentValueReport.isStacked = false;

        this.contentValueReport.drawChartContentValueReporting(contentValueReport);
    }

    public setContentValueEngagementReport(contentValueReportEngagement: any): void {

        this.getTemplateViewModel().contentValueEngagementReport(contentValueReportEngagement);

        contentValueReportEngagement.category = "category";
        contentValueReportEngagement.yAxis = "avgTimeOnPage";
        contentValueReportEngagement.xAxis = "category";
        contentValueReportEngagement.name = "Avg. Time On Page";
        contentValueReportEngagement.horizontalCenter = "middle";
        contentValueReportEngagement.minimalValue = 0;
        contentValueReportEngagement.isStacked = false;

        this.contentValueReportEngagement.drawChartContentValueEngagementReporting(contentValueReportEngagement);
    }

    public setViewModelFromRequest(urlParams){

        //check if URL has filters or user preferences
        if (urlParams != null){

            // date filters.
            if(urlParams.dateFilterType){
                this.dateFilter.getTemplateViewModel().selectedFilter(urlParams.dateFilterType);
            }
            if(urlParams.startDateRange || urlParams.endDateRange){

                this.dateFilter.setRange(urlParams.startDateRange, urlParams.endDateRange);
            }

            if(urlParams.startDate || urlParams.endDate) {
                this.setDateFilters(urlParams.startDate, urlParams.endDate);
            }
        }
    }

    private setDateFilters(startDate, endDate) {
        if(startDate){
            startDate = new Date(startDate.replace(/-/g, '\/'));
        }
        if(endDate){
            endDate = new Date(endDate.replace(/-/g, '\/'));
        }

        this.dateFilter.setDateRange(startDate, endDate);
    }

    public buildDatePickerCalendar(){

        this.dateFilter.buildCalendar();
    }

    public setSearchPresets(presets){
        this.filterPreset.setSearchPresets(presets);
    }

    public addCreatedPresetToList(response){
        this.filterPreset.addCreatedPresetToList(response);
    }

    protected onClickTabLeft(tab) {
        this.getTemplateViewModel().selectedTabLeft(null);
        this.getTemplateViewModel().selectedTabLeft(tab);
    }

    public setContentSuggestionsUsage(contentSuggestionsUsage: any): void {

        contentSuggestionsUsage.forEach(group => {
            let chartData = [
                {
                    category: "With Suggestions",
                    count: group.percentageWithSuggestions,
                    color: am4core.color("#4741a8") // Green color for with suggestions
                },
                {
                    category: "Without Suggestions",
                    count: group.percentageWithoutSuggestions,
                    color: am4core.color("#D2005C") // Red color for without suggestions
                }
            ];
    
            this.drawChartForGroup(group.groupName, chartData);
        });
    }

    public drawChartForGroup(groupName, chartData) {
        let _this = this;

        switch(groupName){
            case "Affiliate ":
                _this.contentSuggestionsUsageAffiliate.drawChart(chartData);
                break;
            case 'Authority':
                _this.contentSuggestionsUsageAuthority.drawChart(chartData);
                break;
            case 'Feature' :
                _this.contentSuggestionsUsageFeature.drawChart(chartData);
                break;
            case 'List' :
                _this.contentSuggestionsUsageList.drawChart(chartData);
                break;
            case 'News':
                _this.contentSuggestionsUsageNews.drawChart(chartData);
                break;
            case 'Resource':
                _this.contentSuggestionsUsageResource.drawChart(chartData);
                break;
        }
    }
    public setContentSuggestionUsageReport(contentSuggestionUsageReport: any): void {

        this.getTemplateViewModel().contentSuggestionUsageReport(contentSuggestionUsageReport);
        let chartData = [];

        contentSuggestionUsageReport.forEach(group => {
            chartData.push({
                category: "With Suggestions",
                count: group.avgTimeOnPageWithSuggestions,
                color: "#4CAF50" // Green color for with suggestions
            });
    
            chartData.push({
                category: "Without Suggestions",
                count: group.avgTimeOnPageWithoutSuggestions,
                color: "#F44336" // Red color for without suggestions
            });
        });


        this.contentSuggestionUsageReport.drawColumnChart(chartData);
    }

    public setContentSuggestionsCountByBrand(contentSuggestionsCountByBrand: any): void {
        this.getTemplateViewModel().contentSuggestionsCountByBrand(contentSuggestionsCountByBrand);
    }

    public setBrand(brand) {
        this.getTemplateViewModel().brand(brand);
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/content_value_reporting_template.ts